import { defaultHttpClient } from '../../httpClient';
import type { GoodsBasicResponse } from './types';

export const getGoodsBasic = (goodsSno: number, fixedCouponSno?: number) => {
  return defaultHttpClient
    .request<GoodsBasicResponse>({
      method: 'GET',
      url: `/api/v3/goods/${goodsSno}/basic/`,
      params: fixedCouponSno ? { fixed_coupon_sno: fixedCouponSno } : undefined,
    })
    .then(result => result.data)
    .then(result => result.goods);
};
